import React, { useEffect, useState } from "react";
import "./BusinessProfile.css";

const BusinessProfile = ({ business, saving, onSave }) => {
  const [formData, setFormData] = useState({
    ownerName: "",
    phone: "",
    email: "",
    gender: "",
    providerType: "",

    business: {
      businessName: "",
      description: "",
      experience: "",
      foodType: "Both",
      gstNumber: "",
      fssaiNumber: "",
      deliveryRadius: 5,
      minimumOrder: 0,
      priceRange: "",
      cuisines: [],
      services: [],
    },
  });
  const serviceOptions = [
  "Home Delivery",
  "Takeaway",
  "Dine In",
  "Party Orders",
  "Bulk Orders",
  "Catering",
  "Corporate Orders",
  "Self Pickup",
];

  useEffect(() => {
    if (business) {
      setFormData({
        ownerName: business.ownerName || "",
        phone: business.phone || "",
        email: business.email || "",
        gender: business.gender || "",
        providerType: business.providerType || "",

        business: {
          businessName: business.business?.businessName || "",
          description: business.business?.description || "",
          experience: business.business?.experience || "",
          foodType: business.business?.foodType || "Both",
          gstNumber: business.business?.gstNumber || "",
          fssaiNumber: business.business?.fssaiNumber || "",
          deliveryRadius:
            business.business?.deliveryRadius || 5,
          minimumOrder:
            business.business?.minimumOrder || 0,
          priceRange:
            business.business?.priceRange || "",
          cuisines:
            business.business?.cuisines || [],
          services:
            business.business?.services || [],
        },
      });
    }
  }, [business]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBusinessChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      business: {
        ...prev.business,
        [name]: value,
      },
    }));
  };

  const handleArray = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      business: {
        ...prev.business,
        [field]: value
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean),
      },
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="business-card">

      {/* Header */}

      <div className="card-header">

        <div>
          <h3>🏪 Business Profile</h3>

          <p>
            Update your business information displayed to customers.
          </p>
        </div>

        <span className="verified-badge">
          ✓ Verified
        </span>

      </div>

      <form onSubmit={submitHandler}>

        {/* ===========================
            Basic Information
        =========================== */}

        <div className="profile-section">

          <h4>👤 Basic Information</h4>

          <div className="business-grid">

            <div className="form-group">
              <label>Owner Name</label>

              <input
                type="text"
                name="ownerName"
                value={formData.ownerName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Phone</label>

              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Email</label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Gender</label>

              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Provider Type</label>

              <input
                type="text"
                name="providerType"
                value={formData.providerType}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Business Name</label>

              <input
                type="text"
                name="businessName"
                value={formData.business.businessName}
                onChange={handleBusinessChange}
              />
            </div>

          </div>

        </div>

        {/* ===========================
            Business Information
        =========================== */}

        <div className="profile-section">

          <h4>🏪 Business Information</h4>

          <div className="business-grid">

            <div className="form-group full-width">
              <label>Description</label>

              <textarea
                name="description"
                value={formData.business.description}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>Experience</label>

              <input
                type="text"
                name="experience"
                value={formData.business.experience}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>Food Type</label>

              <select
                name="foodType"
                value={formData.business.foodType}
                onChange={handleBusinessChange}
              >
                <option>Veg</option>
                <option>Non-Veg</option>
                <option>Both</option>
              </select>
            </div>

            <div className="form-group">
              <label>GST Number</label>

              <input
                type="text"
                name="gstNumber"
                value={formData.business.gstNumber}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>FSSAI Number</label>

              <input
                type="text"
                name="fssaiNumber"
                value={formData.business.fssaiNumber}
                onChange={handleBusinessChange}
              />
            </div>

          </div>

        </div>
                {/* ===========================
            Delivery Settings
        =========================== */}

        <div className="profile-section">

          <h4>🚚 Delivery Settings</h4>

          <div className="business-grid">

            <div className="form-group">
              <label>Delivery Radius (KM)</label>

              <input
                type="number"
                name="deliveryRadius"
                value={formData.business.deliveryRadius}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>Minimum Order (₹)</label>

              <input
                type="number"
                name="minimumOrder"
                value={formData.business.minimumOrder}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>Price Range</label>

              <input
                type="text"
                name="priceRange"
                placeholder="₹100 - ₹500"
                value={formData.business.priceRange}
                onChange={handleBusinessChange}
              />
            </div>

            <div className="form-group">
              <label>Cuisines</label>

              <input
                type="text"
                placeholder="South Indian, North Indian, Chinese"
                value={formData.business.cuisines.join(", ")}
                onChange={(e) =>
                  handleArray("cuisines", e.target.value)
                }
              />
            </div>

           <div className="form-group full-width">

  <label>Services</label>

  <div className="services-grid">

    {serviceOptions.map((service) => (

      <label key={service} className="service-item">

        <input
          type="checkbox"
          checked={formData.business.services.includes(service)}
          onChange={(e) => {

            const updated = e.target.checked
              ? [...formData.business.services, service]
              : formData.business.services.filter(
                  (item) => item !== service
                );

            setFormData((prev) => ({
              ...prev,
              business: {
                ...prev.business,
                services: updated,
              },
            }));
          }}
        />

        <span>{service}</span>

      </label>

    ))}

  </div>

</div>

          </div>

        </div>

        {/* ===========================
            Footer
        =========================== */}

        <div className="profile-footer">

          <div className="profile-note">
            <strong>💡 Tips</strong>

            <br />

            Complete your business profile with accurate
            information. Customers are more likely to trust
            businesses that provide detailed descriptions,
            delivery information, and available services.
          </div>

          <button
            type="submit"
            className="save-btn"
            disabled={saving}
          >
            {saving ? "Saving..." : "💾 Save Profile"}
          </button>

        </div>

      </form>

    </div>
  );
};

export default BusinessProfile;